export enum NetworkStatus {
  ONLINE,
  UNSTABLE,
  OFFLINE,
}

export type NetworkState = {
  status: NetworkStatus;
  rtt: number | null;
  effectiveType: string | null;
  reconnectCount: number;
  lastChangedAt: number | null;
};